export default __webpack_public_path__ + "static/media/LBW.ed1b9d17.webp";